export const exploreContainer = {
  minH: "100vh",
  w: "100%",
  p: { base: 0, md: "1rem" },
  maxW: "975px",
  margin: "0 auto",
  mb: { base: "4.2rem", md: "0.4rem" },
};

export const homeLoaderStyle = {
  w: { base: "100%", lg: "auto" },
  alignItems: "center",
  minW: { md: "468px" },
};
